// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    InvoicePaymentHistoryCollectionModel,
    xngGetInvoicePaymentHistory,
} from "@eisinc/App/Services/InvoicePaymentHistoryService";
import { GetInvoicePaymentHistoryApiParameter } from "@eisinc/App/Store/Reducers";
import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetInvoicePaymentHistoryApiParameter, InvoicePaymentHistoryCollectionModel>;

export const DispatchBeginLoadInvoicePaymentHistory: HandlerType = props => {
    props.dispatch({
        type: "Data/InvoicePaymentHistory/BeginLoadInvoicePaymentHistory",
        parameter: props.parameter,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await xngGetInvoicePaymentHistory(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 404) {
            props.dispatch({ type: "Data/InvoicePaymentHistory/FailedToLoadInvoicePaymentHistory" } as any);
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadInvoicePaymentHistory: HandlerType = props => {
    props.dispatch({
        type: "Data/InvoicePaymentHistory/CompleteLoadInvoicePaymentHistory",
        collection: props.apiResult,
        parameter: props.parameter,
    } as any);
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadInvoicePaymentHistory,
    RequestDataFromApi,
    DispatchCompleteLoadInvoicePaymentHistory,
];

const loadInvoicePaymentHistory = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadInvoicePaymentHistory");
export default loadInvoicePaymentHistory;
